import {useTranslations} from 'next-intl';
import TranslatedInlineLink from './TranslatedInlineLink';

const GuestCard = () => {
  const t = useTranslations('loyalty');
  return (
    <div className="bg-secondary-light rounded-2xl ">
      <div className="p-6">
        <h6 className="mb-0 text-center">
          {t.rich('commons.guestCard', {
            login: (c) => (
              <TranslatedInlineLink href="/login">{c}</TranslatedInlineLink>
            ),
            register: (c) => (
              <TranslatedInlineLink href="/signup">{c}</TranslatedInlineLink>
            ),
          })}
        </h6>
      </div>
    </div>
  );
};

export default GuestCard;
